import React, { useState, useEffect } from "react";
import "../assets/styles/Features.css";

import villa1 from "../assets/features/features-1.jpeg";
import villa2 from "../assets/features/features-2.jpeg";
import villa3 from "../assets/features/features-3.jpeg";
import villa4 from "../assets/features/features-4.jpeg";

const features = [
  { img: villa1, title: "Party Lounge" },
  { img: villa2, title: "Multipurpose Hall" },
  { img: villa3, title: "Bedroom" },
  { img: villa4, title: "Swimming Pool" },
];

function Features() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const slider = setInterval(() => {
      setIndex((prev) => (prev + 1) % features.length);
    }, 3500);

    return () => clearInterval(slider);
  }, []);

  const getClass = (i) => {
    if (i === index) return "feature-card active";
    if (i === (index - 1 + features.length) % features.length)
      return "feature-card left";
    if (i === (index + 1) % features.length) return "feature-card right";
    return "feature-card hidden";
  };

  return (
    <section id="features" className="features-section">
      {/* background blur */}
      <div className="features-bg"></div>

      {/* overlay */}
      <div className="features-overlay"></div>

      <div className="container-boxed features-inner">
        <div className="section-head">
          <span className="section-eyebrow">Signature Amenities</span>

          <h2 className="section-title">
            Discover a Collection of Premium Amenities
          </h2>

          <p className="section-desc">
            Enjoy beautifully designed spaces including rooftop leisure areas,
            celebration halls, luxury suites, and thoughtfully crafted
            environments that redefine comfort and hospitality.
          </p>
        </div>

        {/* carousel */}
        <div className="features-carousel">
          {features.map((item, i) => (
            <div key={i} className={getClass(i)}>
              <img src={item.img} alt={item.title} />

              {i === index && (
                <div className="feature-caption">{item.title}</div>
              )}
            </div>
          ))}
        </div>

        {/* punch line */}
        <p className="feature-tagline">
          Where Every Space Is Designed to <em>Elevate</em> Your Experience
        </p>
      </div>
    </section>
  );
}

export default Features;
